import { render, staticRenderFns } from "./UAS7.vue?vue&type=template&id=1116fdab&scoped=true&"
import script from "./UAS7.vue?vue&type=script&lang=js&"
export * from "./UAS7.vue?vue&type=script&lang=js&"
import style0 from "./UAS7.vue?vue&type=style&index=0&id=1116fdab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116fdab",
  null
  
)

export default component.exports